/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomerWithPointOfSaleV1Dto } from './CustomerWithPointOfSaleV1Dto';
export type ContractingPartyCustomerToContractV1Dto = {
  /**
   * The unique identifier of the entity.
   */
  readonly id: string;
  /**
   * The date when the entity was created.
   */
  readonly createdAt: string;
  /**
   * The date when the entity was modified.
   */
  readonly modifiedAt: string;
  /**
   * The current version of the entity
   */
  version: number;
  /**
   * The role of the contracting-party in the contract.
   */
  role: ContractingPartyCustomerToContractV1Dto.role;
  /**
   * The date from which the relation is valid.
   */
  validFrom?: string | null;
  /**
   * The date until which the relation is valid.
   */
  validTo?: string | null;
  /**
   * The customer linked to this relation.
   */
  customer?: CustomerWithPointOfSaleV1Dto | null;
};
export namespace ContractingPartyCustomerToContractV1Dto {
  /**
   * The role of the contracting-party in the contract.
   */
  export enum role {
    PROPERTY_OWNER = 'Property Owner',
    PROPERTY_LANDLORD = 'Property Landlord',
    PROPERTY_TENANT = 'Property Tenant',
    PROPERTY_MANAGER = 'Property Manager',
    CENTER_MANAGEMENT = 'Center Management',
    ADVERTISING_ASSOCIATION = 'Advertising Association',
    UTILITY_MANAGER = 'Utility Manager',
    CREDITOR_PAYEE_ = 'Creditor (Payee)',
  }
}
